export default __webpack_public_path__ + "static/media/tempStore8.c6e65d01.png";